// main.js
import { createApp } from 'vue'
import request from './utils/request'; // 导入配置好的 axios 实例
import requestT from './utils/requestTemp';//导入临时的axios实例，负责进行前端假数据访问
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/css/global.css';

// 引入路由
import router from './router'
// 引入 Element Plus 图标（可选，按需引入）
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

//全局标题
const PLATFORM_NAME = "本溪高新区科技创新综合服务平台"
const app = createApp(App)
// 注册 Element Plus
app.use(ElementPlus, {
  // 全局配置 el-image
  image: {
    previewAppendToBody: true  // 默认为 false，改为 true
  }
});

// 注册所有图标（可选）
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
//注册 axios
app.config.globalProperties.$http = request;
app.config.globalProperties.$httpTemp = requestT;
app.config.globalProperties.$platformName = PLATFORM_NAME
app.use(router)
app.mount('#app')



